export default "/react/logoApiMonster-9304b085.png";